/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useLayoutEffect, useRef } from "react";
import { useState } from "react";
import { Avatar, Dropdown, Badge, Tooltip, Input, Progress } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";
import { API_URL } from "../../../helper/axioscontants";
import Logo from "../../../assets/landingFeatures/explorer.png";
import cloudIcon from "../../../assets/upload.png";
import Notifications from "../../../assets/notifications.svg";
import Settings from "../../../assets/settings.svg";
import Breadcrumb from "../breadcrumb/breadcrumbs";
import {
  DownOutlined,
  UserOutlined,
  LogoutOutlined,
  FormOutlined,
} from "@ant-design/icons";

import "./nujobsheader.scss";
import useMembersStore from "../../../store/members.store";

import useAuthStore from "../../../store/auth.store";
import { useGlobalStore } from "../../../store/useGlobalStore";
import useSearchJDStore from "../../../store/searchjd.store";
import useSettingstore from "../../../store/settings.store";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";

const NUJobsHeader = () => {
  const [toolTipOpen, setToolTipOpen] = useState(false);
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  const [searchBarInput, setSearchBarInput] = useState("");  
  const { getTeamMembers, teamMembers, currSubscription,checkSubscriptions } = useMembersStore();
  const {profileCompleted,incompleteJDs} = useNuJobDetailsStore();  
  const {nujobsUserLogout} = useAuthStore();
  const { clearSearchedJds } = useSearchJDStore();
  const {  getSettingByKey } =
    useSettingstore();
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const nujUserDetails = JSON.parse(localStorage.getItem("nujobsUserDetails"));
  const [subscriptionIsActive, setSubscriptionIsActive] = useState(false);
  const location = useLocation();
  const navContainerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(8);

  const resetForcedLogoutFlag = useGlobalStore(
    (state) => state.resetForcedLogoutFlag,
  );
  const forcedLogoutFlag = useGlobalStore((state) => state.forcedLogoutFlag);

  const checkSub =() =>{
      if(userDetails?.permission === "superuser" ||
                     currSubscription === "trial_active" || currSubscription === "subscription_active"){
       setSubscriptionIsActive(true)
    }
  }
  useEffect(() => {
    resetForcedLogoutFlag();
    getTeamMembers();
    checkSubscriptions();
    const persistedSearchInput = getSettingByKey("searchInput")?.value;
    if (persistedSearchInput) {
      setSearchBarOpen(true);
      setSearchBarInput(persistedSearchInput);
    }
  }, []);

  useEffect(() => {
    checkSub()
  }, [currSubscription]);

  useEffect(() => {
    const isSearchPage = location.pathname.includes("searchJd");
    if (isSearchPage) {
      setSearchBarOpen(false);
    }
    if (!isSearchPage) {
      setSearchBarInput("");
      setSearchBarOpen(false);
      clearSearchedJds();
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleAwayStatus = () => {
      if (document.visibilityState === "hidden" && userDetails?.qhoid) {
        const url = `${API_URL}/session/activestatus/${userDetails?.qhoid}/${userDetails?.qhuid}/away`;

        // Use native fetch + keepalive to ensure it fires during tab close
        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ _ignoreLoading: true }),
          keepalive: true,
        });
        localStorage.setItem("activestatus", "away");
      }
    };

    document.addEventListener("visibilitychange", handleAwayStatus);
    window.addEventListener("pagehide", handleAwayStatus);

    return () => {
      document.removeEventListener("visibilitychange", handleAwayStatus);
      window.removeEventListener("pagehide", handleAwayStatus);
    };
  }, []);

  const handleLogOut = () => {
        nujobsUserLogout();
        //localStorage.removeItem("userDetails");
        //console.log("Navigating Home Initiated")
        navigate(`/home`);
  };

  useEffect(() => {
    if(forcedLogoutFlag){
        resetForcedLogoutFlag()
        //console.log("Logout Initiated")
        handleLogOut();        
    }
  }, [forcedLogoutFlag]);

  const activeStatus = localStorage.getItem("activestatus") || "online";


  const handleProfile = () => {
        navigate(`nujobsprofile`);
  };

  const handleSubscriptions = () => {
        navigate('nujobssubscription')
      }; 
  
  const handleAnalytics = () => {
        navigate('nujobsuseranalytics')
      };   
      
  const allNavLinks = [
    {
      to: "/nujobshome/nujobssearch",
      label: "Search Home",
      end: true,
      public: true,
    },
    { to: "/nujobshome/nujobsAppliedJobsSearchResults", label: "Applied Jobs", public: false },
    {    
      to: "/nujobshome/nujobsFavJobsSearchResults",
      label: "Fav Jobs",
      end: true,
      public: true,
    },
    {
      to: "/nujobshome/nujobsCandidateProfile",
      label: "My Profile",
      end: true,
      public: true,
    },
    {
      to: "/nujobshome/nujobsMyResumes",
      label: "My Resumes",
      end: true,
      public: true,
    },
    { to: "/nujobshome/nujobsEvaluations", label: "Evals", public: false },
  ];

  const allowedLinks = allNavLinks.filter((link) => {
    if (link.public) return true;
    return true;
  });
    const items = [
        {
            label: (
                <div className="e-mail">
                    {nujUserDetails?.email}
                </div>
            ),
            key: "0",
        },        
        {
            label: (
                <div className="log-out" onClick={handleProfile}>
                    Profile
                </div>
            ),
            key: "1",
            icon: <UserOutlined />,
        },
        {
            label: (
                <div className="log-out" onClick={handleSubscriptions}>
                    Subscription
                </div>
            ),
            key: "2",
            icon: <FormOutlined />,                  
        }, 
        {
            label: (
                <div className="log-out" onClick={handleAnalytics}>
                    Analytics
                </div>
            ),
            key: "3",
            icon: <FormOutlined />,                  
        },         
        {
            label: (
                <div className="log-out" onClick={handleLogOut}>
                    Logout
                </div>
            ),
            key: "4",
            icon: <LogoutOutlined />,
        },
    ];

  function getDropDownItems() {
        return items
      };        
  const colors = ["#f56a00", "#87d068", "#1890ff", "#ffc107", "#d32f2f"];

  const handleOpenChange = (visible) => {
    setToolTipOpen(visible); // updates on hover
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      if (!navContainerRef.current) return;

      const container = navContainerRef.current;
      // We target the individual link elements
      const children = Array.from(
        container.querySelectorAll(".links:not(.more-menu-trigger)"),
      );
      const containerWidth = container.getBoundingClientRect().width;

      // If the container hasn't rendered with width yet, don't hide everything
      if (containerWidth <= 0) return;

      let currentWidth = 0;
      let count = 0;
      const moreButtonWidth = 80; // Give the "More" button a bit more breathing room
      const gap = 36; // Matches the gap in your CSS

      for (let i = 0; i < allowedLinks.length; i++) {
        // Try to get the actual width of the rendered child if it exists,
        // otherwise estimate (approx 100px) for the first calculation
        const itemWidth = children[i]?.offsetWidth || 100;

        currentWidth += itemWidth + gap;

        // If adding this item exceeds width, stop here
        if (currentWidth + moreButtonWidth > containerWidth) {
          break;
        }
        count++;
      }

      // Safety check: always show at least the first item (Home)
      const finalCount = count === 0 ? 1 : count;

      // Only update state if the count actually changed to prevent render loops
      setVisibleCount((prev) => (prev !== finalCount ? finalCount : prev));
    };

    const observer = new ResizeObserver(() => {
      // Wrap in requestAnimationFrame to avoid "ResizeObserver loop limit exceeded" error
      window.requestAnimationFrame(handleResize);
    });

    if (navContainerRef.current) {
      observer.observe(navContainerRef.current);
      // Initial call to set correct state immediately
      handleResize();
    }

    return () => observer.disconnect();
  }, [allowedLinks]);

  const visibleNav = allowedLinks.slice(0, visibleCount);
  const hiddenNav = allowedLinks.slice(visibleCount);

  // Map hidden items for Ant Design Dropdown
  const moreItems = hiddenNav.map((link, idx) => ({
    key: `hidden-${idx}`,
    label: <Link to={link.to}>{link.label}</Link>,
  }));

  if (forcedLogoutFlag) return <></>;

  return (
    <div className="nujobsnavbar-container">
      <nav className="nujobsnavbar-wrapper">
        <div className="navbar-wrapper-left">
          <div className="logo-wrapper">
            <img src={Logo} className="logo" alt="QuallyHire" />
          </div>
          <div
            className="services-links-wrapper"
            ref={navContainerRef}
            style={{
              flex: 1,
              display: "flex",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {visibleNav.map((link) => (
              <NavLink
                key={link.label}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  `links ${isActive ? "active-links" : ""}`
                }
              >
                {link.label}
              </NavLink>
            ))}

          {hiddenNav.length > 0 && (
            <Dropdown menu={{ items: moreItems }} trigger={["hover"]}>
              <a
                className="links more-menu-trigger"
                onClick={(e) => e.preventDefault()}
              >
                More <DownOutlined style={{ fontSize: "10px" }} />
              </a>
            </Dropdown>
          )}
        </div>
      </div>
      <div className="info-wrapper_1">     
        <Badge
          className="info-logo"
          size="small"
          count={incompleteJDs?.length > 0 ? incompleteJDs?.length : ""}
        >
          <img
            src={Notifications}
            alt="Notifications"
            onClick={() => {
              navigate("/nujobshome/nujobsnotifications");
              //markNotificationAsRead();
            }}
          />
        </Badge>
        <Dropdown
          menu={{ items: getDropDownItems() }}
          trigger={["click"]}
          onClick={() => setToolTipOpen(false)}
        >
          <Tooltip
            open={toolTipOpen}
            onOpenChange={handleOpenChange}
            title={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  margin: "10px",
                  gap: "8px",
                }}
              >
                <Progress
                  type="circle"
                  percent={profileCompleted}
                  width={80} // Total width of the progress circle
                  strokeWidth={6} // Thickness of the progress bar
                  strokeColor={{
                    "0%": "#108ee9",
                    "100%": "#87d068",
                  }} // Optional: Adds a nice gradient
                />
                <div>Profile Completion</div>
                <div>
                  <p style={{ marginBottom: "0px" }}>{userDetails?.username}</p>
                  <p style={{ marginBottom: "5px" }}>{userDetails?.email}</p>
                </div>
              </div>
            }
            placement="bottomRight"
            color="white"
            overlayInnerStyle={{
              color: "black",
              fontWeight: "bold",
              maxWidth: "max-content", // ✅ correct place for this
              whiteSpace: "nowrap",
              width: "300px",
            }}
          >
            <Badge
              dot={true}
              color={activeStatus === "online" ? "#00A67E" : "#FFDE21"}
              offset={[-7, 2]}
            >
              <Progress
                type="circle"
                percent={profileCompleted}
                width={42} // Total width of the progress circle
                strokeWidth={6} // Thickness of the progress bar
                strokeColor={{
                  "0%": "#108ee9",
                  "100%": "#87d068",
                }} // Optional: Adds a nice gradient
                format={() => (
                  // <Avatar
                  //   size={80} // Must be smaller than Progress width to fit inside
                  //   src={src}
                  //   icon={!src && <UserOutlined />}
                  // />
                  <Avatar className="user-avatar">
                    {nujUserDetails?.username[0]}
                  </Avatar>
                )}
              />
            </Badge>
          </Tooltip>
        </Dropdown>
      </div>
    </nav>
      <div className="bread_crumb">
        <Breadcrumb />
      </div>
    </div>
  );
};

export default NUJobsHeader;
